module.exports = __webpack_public_path__ + "img/Menu-05.f71f7972.webp";